export enum Slices {
  ROLES = 'roles',
  SCHEDULED_BATCHES = 'scheduled-batches',
  SCHEDULED_BATCH = 'scheduled-batch',
  SCROLL = 'scroll',
  SECURITY_AUDITS = 'security-audits',
  SETTINGS = 'settings',
  STANDARD_OUT = 'standard-out',
  USER = 'user',
  BATCH_DEFINITION_DEP = 'batch-definition-dep',
  BATCH_DEFINITION = 'batch-definition',
  BATCH_DEFINITIONS = 'batch-definitions',
  BATCHES = 'batches',
  BATCH = 'batch',
  CONTAINER = 'container',
  CONTAINERS = 'containers',
  FILE = 'file',
  JOB_DEFINITION = 'job-definition',
  JOB_DEFINITIONS = 'job-definitions',
  JOB = 'job',
  JOBS = 'jobs',
  LOGS = 'logs',
  LOOKUPS = 'lookups',
  MODALS = 'modals',
  ORGANIZATIONS = 'organizations',
  PARAMETER = 'parameter',
  PARAMETERS = 'parameters',
  PROJECT_PARAMETERS = 'project-parameters',
  PROJECT = 'project',
  PROJECTS = 'projects',
  QUERY_PARAMETERS = 'query-parameters',
  PREVENT_PREEMPTIONS_LIST = 'prevent-preemptions-list',
  MAX_RESULTS_LIST = 'max-results-list',
  FILE_STATES_LIST = 'file-states-list',
  JOB_STATES_LIST = 'job-states-list',
  PARAMETER_DIRECTIONS_LIST = 'parameter-directions-list',
  PARAMETER_METHODS_LIST = 'parameter-methods-list',
  REFERENCE_TYPES_LIST = 'reference-types-list',
  RESULT_METHODS_LIST = 'result-methods-list',
  CONTAINER_STATES_LIST = 'container-states-list',
  LOCATION_LIST = 'locations-list',
  CPU_ARCHITECTURES_LIST = 'cpu-architectures-list',
  LOCATION_GROUPS_LIST = 'location-groups-list',
  SYSTEM_PARAMETERS_LIST = 'system-parameters-list',
  INTERVALS_LIST = 'intervals-list',
  SCHEDULED_BATCH_HISTORY = 'scheduled-batch-history',
  BATCH_DEFINITION_LIST = 'batch-definition-list',
  SCHEDULED_BATCH_PARAMETERS = 'scheduled-batch-parameters',
  JOB_PARAMETERS = 'job-parameters',
  JOB_DEFINITION_PARAMETERS = 'job-definition-parameters',
  BATCH_PARAMETERS = 'batch-parameters',
  BATCH_DEFINITION_PARAMETERS = 'batch-definition-parameters',
}
